/* Native pinch zoom is a browser operation, never a theme layout change.
   Loaded synchronously before any viewport/scroll listeners on every page. */
(() => {
  'use strict';
  if (window.AK_NATIVE_ZOOM) return;
  const viewport = window.visualViewport;
  const touchDevice = () => navigator.maxTouchPoints > 0 || matchMedia('(pointer:coarse)').matches;
  let active = false;
  let touches = 0;
  let settleTimer = 0;
  const magnified = () => !!viewport && Math.abs(viewport.scale - 1) > .01;
  const zooming = () => touchDevice() && (active || touches > 1 || magnified());
  window.AK_NATIVE_ZOOM = Object.freeze({isZooming: zooming});
  if (!viewport) return;

  function begin() {
    if (!touchDevice()) return;
    active = true;
    clearTimeout(settleTimer);
  }
  function settle() {
    clearTimeout(settleTimer);
    if (!active || touches || magnified()) return;
    settleTimer = setTimeout(() => {
      if (!touches && !magnified()) active = false;
      // No scrollTo, synthetic resize, layout refresh or animation replay.
    }, 200);
  }
  document.addEventListener('touchstart', event => {
    touches = event.touches.length;
    if (touches > 1) begin();
  }, {capture:true, passive:true});
  document.addEventListener('touchend', event => {
    touches = event.touches.length;
    settle();
  }, {capture:true, passive:true});
  document.addEventListener('touchcancel', () => {
    touches = 0;
    settle();
  }, {capture:true, passive:true});
  document.addEventListener('gesturestart', begin, {capture:true, passive:true});
  document.addEventListener('gestureend', settle, {capture:true, passive:true});
  function viewportEvent(event) {
    if (magnified()) begin(); else settle();
    if (zooming()) event.stopImmediatePropagation();
  }
  viewport.addEventListener('resize', viewportEvent, {capture:true, passive:true});
  viewport.addEventListener('scroll', viewportEvent, {capture:true, passive:true});
  function layoutEvent(event) {
    if (zooming()) event.stopImmediatePropagation();
  }
  window.addEventListener('resize', layoutEvent, {capture:true, passive:true});
  window.addEventListener('scroll', layoutEvent, {capture:true, passive:true});
  document.addEventListener('scroll', layoutEvent, {capture:true, passive:true});
})();
